/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import BarChart from "components/barChart";
import DonutChart from "components/donutChart";
import React, { useState } from "react";

export default function StateChart({
  data,
  filters,
  disabledNavigation,
}: Readonly<{
  data: any;
  filters: any;
  disabledNavigation?: boolean;
}>) {
  const [chartType, setChartType] = useState<ApexChart["type"]>("bar");

  const queryParts = [
    "&status=opentotal",
    filters?.assignmentGroup
      ? `&assignmentGroup=${filters.assignmentGroup.id}`
      : "",
    filters?.account ? `&accountId=${filters.account.id}` : "",
    filters?.region ? `&region=${filters.region.id}` : "",
    filters?.date ? `&period=${filters.date.id}` : "",
  ];

  const queryString = queryParts.join("");

  return (
    <div>
      <div className="grid justify-between grid-cols-[1fr_160px] items-center">
        <h4 className="font-semibold text-lg">Open Cases By Activity</h4>
        <Select
          onValueChange={(e) => {
            setChartType(e as ApexChart["type"]);
          }}
          value={chartType}
        >
          <SelectTrigger className="my-3">
            <SelectValue placeholder="Select Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="donut">Donut Chart</SelectItem>
            <SelectItem value="bar">Bar Chart</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {chartType === "donut" && (
        <DonutChart
          data={data || []}
          disabledNavigation={disabledNavigation}
          label="activityType"
          series="count"
          dataKey="activityType"
          queryString={queryString}
        />
      )}
      {chartType === "bar" && (
        <BarChart
          data={data || []}
          disabledNavigation={disabledNavigation}
          label="activityType"
          series="count"
          dataKey="activityType"
          queryString={queryString}
        />
      )}
    </div>
  );
}
